import { equipmentConstants } from './equipment.constants'

const initialState = {
  loadingEquipments: false,
  savingNewEquipment: false,

  selectedEquipment: null,
  loadingSelectedEquipment: false,

  equipmentsForBoat: [],
  equipmentDetailsForBoat: {},
  loadingEquipmentsForBoat: false,

  documentsForEquipments: {},

  loadingDetailsForEquipment: {},
  detailsForEquipmentError: {},

  loadingEquipmentIdAndTitle: false,
  equipmentsIdAndTitle: [],

  equipmentsForDashboard: [],
  loadingEquipmentsForDashboard: false,

  loadingUniqueIdentifierSuggestions: false,
  uniqueIdentifierSuggestions: null,

  loadingUniqueIdentifierCollision: false,
  hasUniqueIdentifierCollision: false,

  sfiEquipmentTree: [],
  loadingSfiEquipmentTree: false,
  sfiEquipmentTreeError: null,

  deletingEquipment: false,
  error: null,
}

export function equipments(state = initialState, action) {
  switch (action.type) {
    case equipmentConstants.SAVING_NEW_EQUIPMENT:
      return {
        ...state,
        savingNewEquipment: true,
      }
    case equipmentConstants.SAVING_NEW_EQUIPMENT_SUCCESS:
      return {
        ...state,
        savingNewEquipment: false,
      }

    case equipmentConstants.SAVING_NEW_EQUIPMENT_ERROR:
      return {
        ...state,
        savingNewEquipment: false,
        error: action.error,
      }

    case equipmentConstants.UPDATE_EQUIPMENT:
      return {
        ...state,
        savingNewEquipment: true,
      }
    case equipmentConstants.UPDATE_EQUIPMENT_SUCCESS:
      return {
        ...state,
        savingNewEquipment: false,
      }

    case equipmentConstants.UPDATE_EQUIPMENT_ERROR:
      return {
        ...state,
        savingNewEquipment: false,
        error: action.error,
      }
    case equipmentConstants.DELETE_EQUIPMENT:
      return {
        ...state,
        deletingEquipment: true,
      }
    case equipmentConstants.DELETE_EQUIPMENT_SUCCESS:
      return {
        ...state,
        deletingEquipment: false,
      }
    case equipmentConstants.DELETE_EQUIPMENT_ERROR:
      return {
        ...state,
        deletingEquipment: false,
      }

    case equipmentConstants.FETCH_DOCUMENTS:
      return {
        ...state,
      }
    case equipmentConstants.FETCH_DOCUMENTS_SUCCESS:
      return {
        ...state,
        documentsForEquipments: {
          ...state.documentsForEquipments,
          [action.equipmentId]: action.equipmentDocuments,
        },
      }

    case equipmentConstants.FETCH_DOCUMENTS_ERROR:
      return {
        ...state,
        error: 'Feil under lasting av dokumenter.',
      }

    case equipmentConstants.FETCH_EQUIPMENT_ID_AND_TITLE_LOADING:
      return {
        ...state,
        loadingEquipmentIdAndTitle: true,
      }
    case equipmentConstants.FETCH_EQUIPMENT_ID_AND_TITLE_SUCCESS:
      return {
        ...state,
        loadingEquipmentIdAndTitle: false,
        equipmentsIdAndTitle: action.equipmentList,
      }
    case equipmentConstants.FETCH_EQUIPMENT_ID_AND_TITLE_ERROR:
      return {
        ...state,
        loadingEquipmentIdAndTitle: false,
        error: action.error,
      }

    case equipmentConstants.FETCH_EQUIPMENT_BY_ID:
      return {
        ...state,
        loadingSelectedEquipment: true,
      }
    case equipmentConstants.FETCH_EQUIPMENT_BY_ID_SUCCESS:
      return {
        ...state,
        loadingSelectedEquipment: false,
        selectedEquipment: action.equipment,
      }
    case equipmentConstants.FETCH_EQUIPMENT_BY_ID_ERROR:
      return {
        ...state,
        loadingSelectedEquipment: false,
        error: action.error,
      }

    case equipmentConstants.FETCH_EQUIPMENTS_FOR_BOAT:
      return {
        ...state,
        loadingEquipmentsForBoat: true,
      }
    case equipmentConstants.FETCH_EQUIPMENTS_FOR_BOAT_SUCCESS:
      return {
        ...state,
        loadingEquipmentsForBoat: false,
        equipmentsForBoat: action.equipments,
      }
    case equipmentConstants.FETCH_EQUIPMENTS_FOR_BOAT_ERROR:
      return {
        ...state,
        loadingEquipmentsForBoat: false,
        error: action.error,
      }

    case equipmentConstants.FETCH_DETAILS_FOR_EQUIPMENT:
      return {
        ...state,
        loadingDetailsForEquipment: {
          ...state.loadingDetailsForEquipment,
          [action.equipmentId]: true,
        },
      }
    case equipmentConstants.FETCH_DETAILS_FOR_EQUIPMENT_SUCCESS:
      return {
        ...state,
        loadingDetailsForEquipment: {
          ...state.loadingDetailsForEquipment,
          [action.equipmentId]: false,
        },
        equipmentDetailsForBoat: {
          ...state.equipmentDetailsForBoat,
          [action.equipmentId]: action.details,
        },
      }
    case equipmentConstants.FETCH_DETAILS_FOR_EQUIPMENT_ERROR:
      return {
        ...state,
        loadingDetailsForEquipment: {
          ...state.loadingDetailsForEquipment,
          [action.equipmentId]: true,
        },
        detailsForEquipmentError: {
          ...state.detailsForEquipmentError,
          [action.equipmentId]: action.error,
        },
      }

    case equipmentConstants.FETCH_EQUIPMENTS_FOR_DASHBOARD:
      return {
        ...state,
        loadingEquipmentsForDashboard: true,
      }
    case equipmentConstants.FETCH_EQUIPMENTS_FOR_DASHBOARD_SUCCESS:
      return {
        ...state,
        loadingEquipmentsForDashboard: false,
        equipmentsForDashboard: action.equipments,
      }
    case equipmentConstants.FETCH_EQUIPMENTS_FOR_DASHBOARD_ERROR:
      return {
        ...state,
        loadingEquipmentsForDashboard: false,
        error: action.error,
      }
    case equipmentConstants.GET_UNIQUE_IDENTIFIER_SUGGESTIONS_LOADING:
      return {
        ...state,
        loadingUniqueIdentifierSuggestions: true,
      }
    case equipmentConstants.GET_UNIQUE_IDENTIFIER_SUGGESTIONS_SUCCESS:
      return {
        ...state,
        loadingUniqueIdentifierSuggestions: false,
        uniqueIdentifierSuggestions: action.suggestions,
      }
    case equipmentConstants.GET_UNIQUE_IDENTIFIER_SUGGESTIONS_ERROR:
      return {
        ...state,
        loadingUniqueIdentifierSuggestions: false,
      }

    case equipmentConstants.GET_UNIQUE_IDENTIFIER_COLLISIONS_LOADING:
      return {
        ...state,
      }
    case equipmentConstants.GET_UNIQUE_IDENTIFIER_COLLISIONS_SUCCESS:
      return {
        ...state,
        hasUniqueIdentifierCollision: action.hasCollision,
        loadingUniqueIdentifierCollision: false,
      }
    case equipmentConstants.GET_UNIQUE_IDENTIFIER_COLLISIONS_RESET:
      return {
        ...state,
        hasUniqueIdentifierCollision: false,
        loadingUniqueIdentifierCollision: false,
      }
    case equipmentConstants.FETCH_SFI_EQUIPMENT_TREE_LOADING:
      return {
        ...state,
        loadingSfiEquipmentTree: true,
      }
    case equipmentConstants.FETCH_SFI_EQUIPMENT_TREE_SUCCESS:
      return {
        ...state,
        loadingSfiEquipmentTree: false,
        sfiEquipmentTree: action.equipmentTree,
      }
    case equipmentConstants.FETCH_SFI_EQUIPMENT_TREE_ERROR:
      return {
        ...state,
        loadingSfiEquipmentTree: false,
        sfiEquipmentTreeError: action.error,
      }
    case equipmentConstants.RESET_EQUIPMENT:
      return {
        ...state,
        equipmentDocuments: [],
        selectedEquipment: null,
        equipmentsForBoat: [],
        equipmentsForDashboard: [],
        hasUniqueIdentifierCollision: false,
        uniqueIdentifierSuggestions: [],
      }
    default: {
      return {
        ...state,
      }
    }
  }
}
